var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFinalStatementIcon = function SvgFinalStatementIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4336 4.97363V43.2736H38.4336V4.97363H10.4336ZM17.4336 41.7736V37.0736H14.4336L20.1336 29.6736V34.3736H23.1336L17.4336 41.7736ZM26.9336 27.4736H14.8336V23.9736H26.9336V27.4736ZM34.0336 20.4736H14.8336V16.9736H34.0336V20.4736ZM34.0336 13.4736H14.8336V9.97363H34.0336V13.4736Z",
    fill: "#0D8426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.034 9.97363H14.834V13.4736H35.034V9.97363Z",
    fill: "#0D8426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M34.034 16.9736H14.834V20.4736H34.034V16.9736Z",
    fill: "#0D8426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.934 23.9736H14.834V27.4736H26.934V23.9736Z",
    fill: "#0D8426"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.1336 29.6738L14.4336 37.0738H17.4336V41.7738L23.1336 34.3738H20.1336V29.6738Z",
    fill: "#0D8426"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFinalStatementIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "final-statement-icon.88ce22afbbde825a0a6ea21dc71eaf9f.svg";